import { render } from "./AppVersionManagement.vue?vue&type=template&id=7bc09328&scoped=true"
import script from "./AppVersionManagement.vue?vue&type=script&lang=js"
export * from "./AppVersionManagement.vue?vue&type=script&lang=js"

import "./AppVersionManagement.vue?vue&type=style&index=0&id=7bc09328&lang=scss"
import "./AppVersionManagement.vue?vue&type=style&index=1&id=7bc09328&lang=scss&scoped=true"
import "./AppVersionManagement.vue?vue&type=style&index=2&id=7bc09328&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc09328"]])

export default __exports__